import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import type { FutureBoardFailure } from "@chronospark/shared";

type Translate = (key: string, options?: object) => string;

interface Props {
  failure: FutureBoardFailure;
  t: Translate;
  /** 版の競合・並びの競合のときに出す「再読み込み」 */
  onReload?: () => void;
  onClose?: () => void;
}

// 失敗の内容を、本文やメモを含めずに表示する。競合のときは、再読み込みを案内する（自動では上書きしない）。
function FailureAlert({ failure, t, onReload, onClose }: Props) {
  const reloadable = failure.kind === "conflict" || failure.kind === "board_conflict" || failure.kind === "rejected";
  return (
    <Alert
      severity="error"
      role="alert"
      onClose={onClose}
      action={
        reloadable && onReload ? (
          <Button color="inherit" size="small" onClick={onReload}>
            {t("futureBoard.actions.reload")}
          </Button>
        ) : undefined
      }
      sx={{ mb: 2 }}
    >
      {failure.kind === "conflict" ? `${t("futureBoard.conflict.title")}：${t("futureBoard.conflict.body")}` : t(failure.messageKey, { limit: failure.limit })}
    </Alert>
  );
}

export default FailureAlert;
